<rt-dropdown-header (click)="$event.preventDefault()">
  @if (hasBackAction()) {
    <rt-icon-button
      prefix
      variant="plain"
      iconName="keyboard-backspace"
      shape="square"
      size="small"
      (click)="goBack.emit()"
    />
  }
  {{ 'app.candidate.disqualify_candidate' | translate }}
</rt-dropdown-header>
<div padding-tb-small-x padding-lr-small>
  <rt-form-field (click)="$event.preventDefault()">
    <rt-input
      [formControl]="searchInputControl"
      [autoFocus]="true"
      [hasClearButton]="true"
      (reset)="resetSearch()"
      (select)="$event.stopPropagation()"
      variant="rounded"
      placeholder="{{ 'app.common.placeholders.search.disqualify_reasons.other' | translate }}"
    >
      <rt-icon prefix name="search" />
    </rt-input>
  </rt-form-field>
</div>

<div class="scroll-container" rtScrollable [rtScrollableSuppressScrollX]="true">
  @if (hasClear()) {
    <rt-dropdown-item (click)="clear.emit()">
      {{ 'app.common.clear' | translate }}
    </rt-dropdown-item>
  }
  @for (disqualifyReason of dropdownItems(); track disqualifyReason.id || disqualifyReason.name) {
    <rt-dropdown-item
      (click)="
        select.emit({
          disqualifyReason,
        })
      "
    >
      <rt-icon prefix name="block" />
      <div class="disqualify-reason-name">
        {{ disqualifyReason.name }}
      </div>
      @if (!disqualifyReason.automations?.length && hasAutomatedActions(disqualifyReason)) {
        <rt-icon
          suffix
          [rtTooltip]="'app.automated_actions.automated_actions' | translate"
          name="automated-actions"
          size="small"
          (click)="$event.stopPropagation(); actionsDetails.emit({ disqualifyReason })"
        />
      } @else if (disqualifyReason.automations?.length) {
        <rt-icon
          suffix
          [rtTooltip]="'app.workflow_automations.automations' | translate"
          name="workflow-action"
          size="small"
          (click)="$event.stopPropagation(); actionsDetails.emit({ disqualifyReason })"
        />
      }
    </rt-dropdown-item>
  }
</div>
@if (hasEditOption()) {
  <rt-dropdown-item
    *rtAbilityGuard="manageDisqualifyReasons"
    (click)="edit.emit()"
    [rtWalkthroughOriginStepId]="'walkthrough-step-proceed-disqualify-5'"
    [rtWalkthroughOriginAfterDispose]="afterWalkthroughTooltipDispose | fnBind: this"
  >
    <rt-icon prefix name="edit" />
    {{ 'app.disqualify_reasons.title' | translate }}
  </rt-dropdown-item>
}
